import { render, staticRenderFns } from "./AppointmentAdd.vue?vue&type=template&id=09b25252"
import script from "./AppointmentAdd.vue?vue&type=script&lang=ts"
export * from "./AppointmentAdd.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentAdd.vue?vue&type=style&index=0&id=09b25252&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports